exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fts-document-modal .document-viewer-container{height:100%}.fts-document-modal .document-viewer-container .document-modal__body{position:relative;padding:0}.fts-document-modal .pdf-app .pdfViewer .page{box-sizing:content-box;border-image:none}.fts-document-modal .loading-indicator{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);-webkit-transform:translate(-50%,-50%);-moz-transform:translate(-50%,-50%);-ms-transform:translate(-50%,-50%);z-index:999}.fts-document-modal .loading-indicator .loading-indicator-label{margin-top:1.5rem}", ""]);

// exports
